export interface JugadorJSON {
  jug_id: string | null;
  jug_nombre: string;
  jug_apellido: string;
  jug_documento_numero: string;
  jug_fecha_nacimiento: Date;
  jug_genero: string;
  jug_domicilio: string;
  jug_proid: number;
  jug_localidad: string;
  jug_cod_postal: string;
  jug_nro_telefono: string;
  jug_email: string;
  jug_foto: string;
  jug_documento_imagen: string;
  jug_cobertura_tipo: string;
  jug_cobertura_empresa: string;
  jug_contacto_1_apellidoynombre: string;
  jug_contacto_1_nro_documento: string;
  jug_contacto_1_nro_telefono: string;
  jug_contacto_2_apellidoynombre: string;
  jug_contacto_2_nro_documento: string;
  jug_contacto_2_nro_telefono: string;
  jug_grupo_factor: string;
  jug_seguro: boolean;
  jug_apto_medico: boolean;
  jug_apto_medico_imagen: string;
  jug_autorizacion_menor: boolean;
  jug_autorizacion_menor_imagen: string;
  jug_activo: boolean;
  jug_estado: string;
  jug_habilitado_fecha: Date | null;
  jug_clubid: number;
  jug_dtiid: number;
  jug_nro_celular: string;
  jug_autorizacion_menor_apellido: string;
  jug_autorizacion_menor_nombre: string;
  jug_autorizacion_menor_nro_telefono: string;
  jug_autorizacion_menor_nro_documento: string;
  jug_clase: number;
  jug_jpid: number;
  jug_paisid: number;
  jug_posee_autorizacion_jugar_mayores: boolean;
  jug_autorizacion_mayores_archivo: string;
}

export interface Genero {
  key: string;
  text: string;
}

export interface Nacionalidad {
  key: string;
  text: string;
}

export class Jugador {
  protected constructor(
    private id: string | null,
    private nombre: string,
    private apellido: string,
    private documentoNumero: string,
    private fechaNacimiento: Date,
    private genero: string,
    private domicilio: string,
    private proid: number,
    private localidad: string,
    private codPostal: string,
    private nroTelefono: string,
    private email: string,
    private foto: string,
    private documentoImagen: string,
    private coberturaTipo: string,
    private coberturaEmpresa: string,
    private contacto1Apellidoynombre: string,
    private contacto1NroDocumento: string,
    private contacto1NroTelefono: string,
    private contacto2Apellidoynombre: string,
    private contacto2NroDocumento: string,
    private contacto2NroTelefono: string,
    private grupofactor: string,
    private seguro: boolean,
    private aptoMedico: boolean,
    private aptoMedicoImagen: string,
    private autorizacionMenor: boolean,
    private autorizacionMenorImagen: string,
    private activo: boolean,
    private estado: string,
    private habilitadoFecha: Date | null,
    private clubid: number,
    private dtiid: number,
    private nroCelular: string,
    private autorizacionMenorApellido: string,
    private autorizacionMenorNombre: string,
    private autorizacionMenorNroTelefono: string,
    private autorizacionMenorNroDocumento: string,
    private clase: number,
    private jpid: number,
    private paisid: number,
    private posee_autorizacion_jugar_mayores: boolean,
    private autorizacion_mayores_archivo: string
  ) {}

  static createFrom(
    id: string | null,
    nombre: string,
    apellido: string,
    documentoNumero: string,
    fechaNacimiento: Date,
    genero: string,
    domicilio: string,
    proid: number,
    localidad: string,
    codPostal: string,
    nroTelefono: string,
    email: string,
    foto: string,
    documentoImagen: string,
    coberturaTipo: string,
    coberturaEmpresa: string,
    contacto1Apellidoynombre: string,
    contacto1NroDocumento: string,
    contacto1NroTelefono: string,
    contacto2Apellidoynombre: string,
    contacto2NroDocumento: string,
    contacto2NroTelefono: string,
    grupofactor: string,
    seguro: boolean,
    aptoMedico: boolean,
    aptoMedicoImagen: string,
    autorizacionMenor: boolean,
    autorizacionMenorImagen: string,
    activo: boolean,
    estado: string,
    habilitadoFecha: Date | null,
    clubid: number,
    dtiid: number,
    nroCelular: string,
    autorizacionMenorApellido: string,
    autorizacionMenorNombre: string,
    autorizacionMenorNroTelefono: string,
    autorizacionMenorNroDocumento: string,
    clase: number,
    jpid: number,
    paisid: number,
    posee_autorizacion_jugar_mayores: boolean,
    autorizacion_mayores_archivo: string
  ) {
    return new this(
      id,
      nombre,
      apellido,
      documentoNumero,
      fechaNacimiento,
      genero,
      domicilio,
      proid,
      localidad,
      codPostal,
      nroTelefono,
      email,
      foto,
      documentoImagen,
      coberturaTipo,
      coberturaEmpresa,
      contacto1Apellidoynombre,
      contacto1NroDocumento,
      contacto1NroTelefono,
      contacto2Apellidoynombre,
      contacto2NroDocumento,
      contacto2NroTelefono,
      grupofactor,
      seguro,
      aptoMedico,
      aptoMedicoImagen,
      autorizacionMenor,
      autorizacionMenorImagen,
      activo,
      estado,
      habilitadoFecha,
      clubid,
      dtiid,
      nroCelular,
      autorizacionMenorApellido,
      autorizacionMenorNombre,
      autorizacionMenorNroTelefono,
      autorizacionMenorNroDocumento,
      clase,
      jpid,
      paisid,
      posee_autorizacion_jugar_mayores,
      autorizacion_mayores_archivo
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: Jugador) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromOffline(id: string, nombre: string, apellido: string, dtiid: number, documento_numero: string) {
    return new this(
      id,
      nombre,
      apellido,
      documento_numero,
      new Date(),
      '',
      '',
      0,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      false,
      false,
      '',
      false,
      '',
      false,
      '',
      null,
      0,
      dtiid,
      '',
      '',
      '',
      '',
      '',
      0,
      0,
      0,
      false,
      ''
    );
  }

  static fromJSON(entity: JugadorJSON) {
    return Jugador.createFrom(
      entity.jug_id,
      entity.jug_nombre,
      entity.jug_apellido,
      entity.jug_documento_numero,
      new Date(entity.jug_fecha_nacimiento),
      entity.jug_genero,
      entity.jug_domicilio,
      entity.jug_proid,
      entity.jug_localidad,
      entity.jug_cod_postal,
      entity.jug_nro_telefono,
      entity.jug_email,
      entity.jug_foto,
      entity.jug_documento_imagen,
      entity.jug_cobertura_tipo,
      entity.jug_cobertura_empresa,
      entity.jug_contacto_1_apellidoynombre,
      entity.jug_contacto_1_nro_documento,
      entity.jug_contacto_1_nro_telefono,
      entity.jug_contacto_2_apellidoynombre,
      entity.jug_contacto_2_nro_documento,
      entity.jug_contacto_2_nro_telefono,
      entity.jug_grupo_factor,
      entity.jug_seguro,
      entity.jug_apto_medico,
      entity.jug_apto_medico_imagen,
      entity.jug_autorizacion_menor,
      entity.jug_autorizacion_menor_imagen,
      entity.jug_activo,
      entity.jug_estado,
      entity.jug_habilitado_fecha ? new Date(entity.jug_habilitado_fecha) : null,
      entity.jug_clubid,
      entity.jug_dtiid,
      entity.jug_nro_celular,
      entity.jug_autorizacion_menor_apellido,
      entity.jug_autorizacion_menor_nombre,
      entity.jug_autorizacion_menor_nro_telefono,
      entity.jug_autorizacion_menor_nro_documento,
      entity.jug_clase,
      entity.jug_jpid,
      entity.jug_paisid,
      entity.jug_posee_autorizacion_jugar_mayores,
      entity.jug_autorizacion_mayores_archivo
    );
  }

  toJSON(): JugadorJSON {
    return {
      jug_id: this.getId(),
      jug_nombre: this.getNombre(),
      jug_apellido: this.getApellido(),
      jug_documento_numero: this.getDocumentoNumero(),
      jug_fecha_nacimiento: this.getFechaNacimiento(),
      jug_genero: this.getGenero(),
      jug_domicilio: this.getDomicilio(),
      jug_proid: this.getProid(),
      jug_localidad: this.getLocalidad(),
      jug_cod_postal: this.getCodPostal(),
      jug_nro_telefono: this.getNroTelefono(),
      jug_email: this.getEmail(),
      jug_foto: this.getFoto(),
      jug_documento_imagen: this.getDocumentoImagen(),
      jug_cobertura_tipo: this.getCoberturaTipo(),
      jug_cobertura_empresa: this.getCoberturaEmpresa(),
      jug_contacto_1_apellidoynombre: this.getContacto1Apellidoynombre(),
      jug_contacto_1_nro_documento: this.getContacto1NroDocumento(),
      jug_contacto_1_nro_telefono: this.getContacto1NroTelefono(),
      jug_contacto_2_apellidoynombre: this.getContacto2Apellidoynombre(),
      jug_contacto_2_nro_documento: this.getContacto2NroDocumento(),
      jug_contacto_2_nro_telefono: this.getContacto2NroTelefono(),
      jug_grupo_factor: this.getGrupoFactor(),
      jug_seguro: this.getSeguro(),
      jug_apto_medico: this.getAptoMedico(),
      jug_apto_medico_imagen: this.getAptoMedicoImagen(),
      jug_autorizacion_menor: this.getAutorizacionMenor(),
      jug_autorizacion_menor_imagen: this.getAutorizacionMenorImagen(),
      jug_activo: this.getActivo(),
      jug_estado: this.getEstado(),
      jug_habilitado_fecha: this.getHabilitadoFecha(),
      jug_clubid: this.getClubid(),
      jug_dtiid: this.getDtiid(),
      jug_nro_celular: this.getNroCelular(),
      jug_autorizacion_menor_apellido: this.getAutorizacionMenorApellido(),
      jug_autorizacion_menor_nombre: this.getAutorizacionMenorNombre(),
      jug_autorizacion_menor_nro_telefono: this.getAutorizacionMenorNroTelefono(),
      jug_autorizacion_menor_nro_documento: this.getAutorizacionMenorNroDocumento(),
      jug_clase: this.getClase(),
      jug_jpid: this.getJpid(),
      jug_paisid: this.getPaisid(),
      jug_posee_autorizacion_jugar_mayores: this.getPoseeAutorizacionJugarMayores(),
      jug_autorizacion_mayores_archivo: this.getAutorizacionMayoresArchivo(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getNombre(): string {
    return this.nombre;
  }

  getApellido(): string {
    return this.apellido;
  }

  getDocumentoNumero(): string {
    return this.documentoNumero;
  }

  getFechaNacimiento(): Date {
    return this.fechaNacimiento;
  }

  getGenero(): string {
    return this.genero;
  }

  getDomicilio(): string {
    return this.domicilio;
  }

  getProid(): number {
    return this.proid;
  }

  getLocalidad(): string {
    return this.localidad;
  }

  getCodPostal(): string {
    return this.codPostal;
  }

  getNroTelefono(): string {
    return this.nroTelefono;
  }

  getEmail(): string {
    return this.email;
  }

  getFoto(): string {
    return this.foto;
  }

  getDocumentoImagen(): string {
    return this.documentoImagen;
  }

  getCoberturaTipo(): string {
    return this.coberturaTipo;
  }

  getCoberturaEmpresa(): string {
    return this.coberturaEmpresa;
  }

  getContacto1Apellidoynombre(): string {
    return this.contacto1Apellidoynombre;
  }

  getContacto1NroDocumento(): string {
    return this.contacto1NroDocumento;
  }

  getContacto1NroTelefono(): string {
    return this.contacto1NroTelefono;
  }

  getContacto2Apellidoynombre(): string {
    return this.contacto2Apellidoynombre;
  }

  getContacto2NroDocumento(): string {
    return this.contacto2NroDocumento;
  }

  getContacto2NroTelefono(): string {
    return this.contacto2NroTelefono;
  }

  getGrupoFactor(): string {
    return this.grupofactor;
  }

  getSeguro(): boolean {
    return this.seguro;
  }

  getAptoMedico(): boolean {
    return this.aptoMedico;
  }

  getAptoMedicoImagen(): string {
    return this.aptoMedicoImagen;
  }

  getAutorizacionMenor(): boolean {
    return this.autorizacionMenor;
  }

  getAutorizacionMenorImagen(): string {
    return this.autorizacionMenorImagen;
  }

  getActivo(): boolean {
    return this.activo;
  }

  getEstado(): string {
    return this.estado;
  }

  getHabilitadoFecha(): Date | null {
    return this.habilitadoFecha;
  }

  getClubid(): number {
    return this.clubid;
  }

  getDtiid(): number {
    return this.dtiid;
  }

  getNroCelular(): string {
    return this.nroCelular;
  }

  getAutorizacionMenorApellido(): string {
    return this.autorizacionMenorApellido;
  }

  getAutorizacionMenorNombre(): string {
    return this.autorizacionMenorNombre;
  }

  getAutorizacionMenorNroTelefono(): string {
    return this.autorizacionMenorNroTelefono;
  }

  getAutorizacionMenorNroDocumento(): string {
    return this.autorizacionMenorNroDocumento;
  }

  getClase(): number {
    return this.clase;
  }

  getJpid(): number {
    return this.jpid;
  }

  getPaisid(): number {
    return this.paisid;
  }

  getPoseeAutorizacionJugarMayores(): boolean {
    return this.posee_autorizacion_jugar_mayores;
  }

  getAutorizacionMayoresArchivo(): string {
    return this.autorizacion_mayores_archivo;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setApellido(value: string): void {
    this.apellido = value;
  }

  setDocumentoNumero(value: string): void {
    this.documentoNumero = value;
  }

  setFechaNacimiento(value: Date): void {
    this.fechaNacimiento = value;
  }

  setGenero(value: string): void {
    this.genero = value;
  }

  setDomicilio(value: string): void {
    this.domicilio = value;
  }

  setProid(value: number): void {
    this.proid = value;
  }

  setLocalidad(value: string): void {
    this.localidad = value;
  }

  setCodPostal(value: string): void {
    this.codPostal = value;
  }

  setNroTelefono(value: string): void {
    this.nroTelefono = value;
  }

  setEmail(value: string): void {
    this.email = value;
  }

  setFoto(value: string): void {
    this.foto = value;
  }

  setDocumentoImagen(value: string): void {
    this.documentoImagen = value;
  }

  setCoberturaTipo(value: string): void {
    this.coberturaTipo = value;
  }

  setCoberturaEmpresa(value: string): void {
    this.coberturaEmpresa = value;
  }

  setContacto1Apellidoynombre(value: string): void {
    this.contacto1Apellidoynombre = value;
  }

  setContacto1NroDocumento(value: string): void {
    this.contacto1NroDocumento = value;
  }

  setContacto1NroTelefono(value: string): void {
    this.contacto1NroTelefono = value;
  }

  setContacto2Apellidoynombre(value: string): void {
    this.contacto2Apellidoynombre = value;
  }

  setContacto2NroDocumento(value: string): void {
    this.contacto2NroDocumento = value;
  }

  setContacto2NroTelefono(value: string): void {
    this.contacto2NroTelefono = value;
  }

  setGrupoFactor(value: string): void {
    this.grupofactor = value;
  }

  setSeguro(value: boolean): void {
    this.seguro = value;
  }

  setAptoMedico(value: boolean): void {
    this.aptoMedico = value;
  }

  setAptoMedicoImagen(value: string): void {
    this.aptoMedicoImagen = value;
  }

  setAutorizacionMenor(value: boolean): void {
    this.autorizacionMenor = value;
  }

  setAutorizacionMenorImagen(value: string): void {
    this.autorizacionMenorImagen = value;
  }

  setActivo(value: boolean): void {
    this.activo = value;
  }

  setEstado(value: string): void {
    this.estado = value;
  }

  setHabilitadoFecha(value: Date): void {
    this.habilitadoFecha = value;
  }

  setClubid(value: number): void {
    this.clubid = value;
  }

  setDtiid(value: number): void {
    this.dtiid = value;
  }

  setNroCelular(value: string): void {
    this.nroCelular = value;
  }

  setAutorizacionMenorApellido(value: string): void {
    this.autorizacionMenorApellido = value;
  }

  setAutorizacionMenorNombre(value: string): void {
    this.autorizacionMenorNombre = value;
  }

  setAutorizacionMenorNroTelefono(value: string): void {
    this.autorizacionMenorNroTelefono = value;
  }

  setAutorizacionMenorNroDocumento(value: string): void {
    this.autorizacionMenorNroDocumento = value;
  }

  setJpid(value: number): void {
    this.jpid = value;
  }

  setPaisid(value: number): void {
    this.paisid = value;
  }

  setPoseeAutorizacionJugarMayores(value: boolean): void {
    this.posee_autorizacion_jugar_mayores = value;
  }

  setAutorizacionMayoresArchivo(value: string): void {
    this.autorizacion_mayores_archivo = value;
  }

  fullname(): string {
    return this.apellido + ', ' + this.nombre;
  }

  fullnameLike(val: string): boolean {
    return this.fullname().toLowerCase().includes(val.toLowerCase());
  }

  static sortByFullameFn = (a: Jugador, b: Jugador) => {
    if (a.fullname() < b.fullname()) {
      return -1; // Orden descendente
    }
    if (a.fullname() > b.fullname()) {
      return 1;
    }
    return 0;
  };

  estaSuspendido() {
    return this.estado === 'Suspendido';
  }
}
